import {ScrollArea as Component} from './scroll-area';
import {useScrollAreaContext} from './context';

export const ScrollArea = Object.assign(Component, {
	useScrollAreaContext,
});
